// extracted by mini-css-extract-plugin
module.exports = {"loader":"attendanceloader_loader__2jakT","load6":"attendanceloader_load6__3XTJh","round":"attendanceloader_round__1kV3_"};